type Props = {
  description?: string | null;
};
export default function Description({ description }: Props) {
  if (!description) return null;
  return <p className="text-sm text-black mb-4">{description}</p>;
}
